var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { View, Animated } from 'react-native';
import R from '../../../core-res/R';
class HelperText extends PureComponent {
    render() {
        const _a = this.props, { helperText, errorText, disabled, focus, theme } = _a, restProps = __rest(_a, ["helperText", "errorText", "disabled", "focus", "theme"]);
        const commonStyle = Object.assign({}, R.typography.uiTiny, { textAlign: 'left', marginBottom: R.spacing.xs });
        let extraStyle = {};
        let renderedText = '';
        if (errorText) {
            renderedText = errorText;
            extraStyle = {
                color: theme.textAlert,
                opacity: focus.interpolate({
                    inputRange: [-1, 0, 1],
                    outputRange: [1, 0, 0],
                }),
                fontSize: helperText
                    ? R.typography.uiTiny.fontSize
                    : focus.interpolate({
                        inputRange: [-1, 0, 1],
                        outputRange: [12, 0, 0],
                    }),
            };
        }
        else {
            renderedText = helperText;
            extraStyle = {
                color: disabled ? theme.textMuted : theme.textSecondary,
                opacity: focus.interpolate({
                    inputRange: [-1, 0, 1],
                    outputRange: [0, 1, 1],
                }),
                fontSize: R.typography.uiTiny.fontSize,
            };
        }
        return (<View>
        <Animated.Text {...restProps} style={[commonStyle, extraStyle]}>
          {renderedText}
        </Animated.Text>
      </View>);
    }
}
HelperText.propTypes = {
    helperText: PropTypes.string,
    errorText: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    focus: PropTypes.instanceOf(Animated.Value).isRequired,
    numberOfLines: PropTypes.number,
    theme: PropTypes.object,
};
HelperText.defaultProps = {
    helperText: '',
    errorText: '',
    numberOfLines: 2,
};
export default HelperText;
